import { Candidate } from "@src/widgets/candidate/ui/Candidate";

import styles from "./styles.module.scss";

export const CandidatePage = () => {
  return (
    <div className={styles.candidateWrap}>
      <Candidate />
    </div>
  );
};
